enum Phase {Draft = 'Draft', Planning = 'Planning', Production = 'Production'}

export default Phase